module.exports = __webpack_public_path__ + "static/media/L10.2150e1d2.jpg";